import { carouselItems } from '@/mocks/home';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 tracking-wide">精选专题</h2>
          <p className="mt-2 text-sm text-foreground-500">精心策划的影视主题合集，发现更多精彩内容</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className={`group cursor-pointer rounded-lg overflow-hidden border border-background-200/70 bg-background-50 transition-all duration-300 hover:-translate-y-1 ${
                i === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`relative ${i === 0 ? 'aspect-[16/9] lg:aspect-auto lg:h-full' : 'aspect-[16/9]'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>
                <div className={`absolute bottom-0 left-0 right-0 p-4 ${i === 0 ? 'p-6' : 'p-4'}`}>
                  <span className="inline-block text-[10px] px-2 py-0.5 rounded-full bg-primary-500/80 text-white mb-2 whitespace-nowrap">
                    {item.tag}
                  </span>
                  <h3 className={`font-semibold text-foreground-950 leading-snug ${i === 0 ? 'text-lg md:text-xl' : 'text-sm'}`}>
                    {item.title}
                  </h3>
                  <p className={`text-foreground-600 mt-1 leading-relaxed ${i === 0 ? 'text-sm' : 'text-xs line-clamp-2'}`}>
                    {item.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}